import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ArrowBack from 'assets/images/ArrowBack.svg';
import SimpleCarousel from 'components/SimpleCarousel';
import NarrativeSmallCard from 'components/Cards/NarrativeSmallCard';
import { sortNarratives } from 'utils/serendipity';
import { getLighterColor, rgbToHex } from 'utils/colors';
import history from 'store/history';
import { NARRATIVE } from 'constants/types';
import {
  StartButton, FineTuneWrapper, YourProgress, YourProfile, Progress,
  ProgressSerendipity, ProfilePic, ViewProfile, TitleBack,
} from './styles';

function FineTune(props) {
  const {
    narratives, user, literals, resetAll, setBreadcrumb,
  } = props;

  const [orderNarratives, setOrderNarratives] = useState(null);
  const [totalProgress, setTotalProgress] = useState(0);

  useEffect(() => {
    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.fineTune,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetAll();
  }, []);

  useEffect(() => {
    let total = 0;
    if (narratives) {
      narratives.forEach((na) => {
        total += na.progress;
      });
      total /= (narratives.length);
      setTotalProgress(total);
    }
  }, [narratives]);


  const printOtherNarratives = () => {
    const { itemsPreferencesFromSerendipity } = props;

    const filterNarratives = _.filter(narratives, (narrative) => {
      if (narrative.type.id === 21227760) {
        return false;
      }

      return true;
    });

    if (!filterNarratives.length) {
      return null;
    }

    const finalNarratives = _.map(filterNarratives, (narrative) => {
      const enabled = !_.find(itemsPreferencesFromSerendipity, item => item.element_type === NARRATIVE && item.element_id === narrative.id && !item.enabled);
      return { ...narrative, enabled };
    });

    if (orderNarratives) {
      finalNarratives.sort((a, b) => {
        const positionA = _.findIndex(orderNarratives, item => item === a);
        const positionB = _.findIndex(orderNarratives, item => item === b);

        return positionA < positionB ? -1 : 1;
      });
    } else {
      finalNarratives.sort(sortNarratives);

      const newOrderNarratives = _.map(finalNarratives, narrative => narrative.id);
      setOrderNarratives(newOrderNarratives);
    }

    const classCard = 'narratives_card';
    const narrativesElements = _.map(finalNarratives, (narrative) => {
      const color = rgbToHex(getLighterColor(narrative.section.color, 15 * narrative.section.position));
      return (
        <NarrativeSmallCard
          key={narrative.id}
          data={narrative}
          color={color}
          literals={literals}
          classesList={classCard}
        />
      );
    });

    const defaultPosition = _.findIndex(finalNarratives, narrative => narrative.progress < 100 && narrative.enabled);

    return (
      <React.Fragment>
        <SimpleCarousel classesList={classCard} defaultPosition={defaultPosition}>
          {narrativesElements}
        </SimpleCarousel>
      </React.Fragment>
    );
  };

  const clickNarrative = (event) => {
    if (event) {
      const id = event.currentTarget.getAttribute('data-id');
      history.push(`/narratives/${id}`);
    }
  };

  const goToProfile = () => {
    history.push('/userprofile');
  };

  const handleGoBack = () => {
    history.goBack();
  };

  const serendipity = () => {
    const { getSerendipityAction } = props;
    const action = getSerendipityAction();
    if (action) {
      action();
    }
  };

  const printGoBack = () => {
    return (
      <TitleBack>
        <div className='title_create'>
          <img src={ArrowBack} alt='' onClick={handleGoBack} />
          <div>
            {literals.fineTune}
            <strong>{literals.serendipity}</strong>
          </div>
        </div>
      </TitleBack>
    );
  };

  const printProgress = (only) => {
    const progress = _.map(narratives, (narr, key) => {
      if (only && key > 2) {
        return null;
      }
      return (
        <Progress progress={30 * (narr.progress / 100)} finish={narr.progress === 100} data-id={narr.id} key={narr.id} onClick={clickNarrative}>
          <img src={narr.image} alt='' />
          <div className='title'>{narr.name}</div>
          {narr.progress > 0 && narr.progress < 100
            ? <div className='percentage'>{`${narr.progress}%`}</div>
            : <div className='new'>New</div>
          }
          {narr.progress === 100
            && <div className='percentage'>{literals.completed}</div>
          }
        </Progress>
      );
    });
    return (
      <div className='progress'>
        {progress}
      </div>
    );
  };

  return (
    <FineTuneWrapper>
      {printGoBack()}
      <div className='top_button'>
        <StartButton onClick={serendipity}>
          <i className='fa fa-play' />
          {literals.start}
        </StartButton>
      </div>
      <div className='top'>
        {printOtherNarratives()}
      </div>
      <div className='bottom'>
        <YourProgress>
          <div className='title'>{literals.progress}</div>
          <div className='subtitle'>{literals.complete}</div>
          <ProgressSerendipity progress={40 * (totalProgress / 100)} />
          {printProgress(false)}
        </YourProgress>
        <YourProfile>
          <ProfilePic img={user.avatar} />
          <div className='name'>{`${user.name} ${user.surname}`}</div>
          {printProgress(true)}
          <ViewProfile onClick={goToProfile}>{literals.viewProfile}</ViewProfile>
        </YourProfile>
        <div style={{ height: '10vh', width: '100%' }} />
      </div>
    </FineTuneWrapper>
  );
}

FineTune.propTypes = {
  setBreadcrumb: PropTypes.func.isRequired,
  resetAll: PropTypes.func.isRequired,
  literals: PropTypes.object.isRequired,
  narratives: PropTypes.array,
  user: PropTypes.object.isRequired,
};

FineTune.defaultProps = {
  narratives: [],
};

export default FineTune;



// WEBPACK FOOTER //
// ./src/routes/FineTune/components/index.jsx